import { RouterService } from './../router.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  faPlusSquare,
  faMinusSquare,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery';

@Component({
  selector: 'app-lottery',
  templateUrl: './lottery.component.html',
  styleUrls: ['./lottery.component.scss'],
})
export class LotteryComponent implements OnInit {
  serverUrl: string;
  title = 'lottery';
  id: string;
  winners: string[] = [];
  count: number;
  subList: SubscriberData[] = [];
  file: File = null;
  numberOfAwards: number;
  awards: Award[] = [];
  faPlusSquare = faPlusSquare;
  faMinusSquare = faMinusSquare;
  faSpinner = faSpinner;
  tenureBounsMonths: number = 3;
  isTenureBouns = false;
  isRepeat = false;
  isForGifter = false;
  space: string = ' ';
  isTwitchLogin: boolean = true;
  isProcessing: boolean = false;
  broadcaster_id: string;
  lotteryPool: string[] = [];
  chooseAward: Award;
  chooseAwardName: string;
  isWinnerGet: boolean = false;
  constructor(
    private http: HttpClient,
    private activateRouter: ActivatedRoute,
    public routerService: RouterService,
    private scrollDispatcher: ScrollDispatcher,
    public cookieService: CookieService
  ) {}
  ngOnInit(): void {
    this.serverUrl = 'https://' + window.location.host + '/twitchApi/';
    this.awards.push(new Award('PS50', 10));
    this.id = this.activateRouter.snapshot.paramMap.get('id');
    this.scrollDispatcher.scrolled().subscribe(() => {
      if ($(window).scrollTop()) {
        $('nav').addClass('black');
      } else {
        $('nav').removeClass('black');
      }
    });
    this.checkAccessToken();
  }
  getWinner() {
    let alreadyPick: string[] = [];
    let count = 0;
    for (let i = 0; i < this.awards.length; i++) {
      const award = this.awards[i];
      award.winner = [];
      for (let j = 0; j < award.numberOfPeople; j++) {
        let isPick = false;
        while (!isPick && count < this.lotteryPool.length) {
          if (alreadyPick.indexOf(this.lotteryPool[count]) === -1 && award.winner.indexOf(this.lotteryPool[count]) === -1) {
            if (!this.isRepeat) {
              alreadyPick.push(this.lotteryPool[count])
            }
            award.winner.push(this.lotteryPool[count])
            isPick = true;
          }
          count++;
        }
      }
    }
    console.log(this.awards);
    this.isWinnerGet = true;
  }
  getWinnerReq(object): Observable<any> {
    return this.http.post(this.serverUrl + 'get_winner/', object, {
      responseType: 'text',
    });
  }

  handleFileInput(files: FileList) {
    if (files.length < 1) {
      return;
    }
    this.subList = [];
    this.file = files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(this.file);
    fileReader.onload = () => {
      let csv = fileReader.result;
      this.subList = this.csvToJson(csv.toString());
    };
  }

  csvToJson(csv: string): SubscriberData[] {
    csv = csv.replace(' ', '');
    let lines = csv.split('\n');
    let result: SubscriberData[] = [];
    let headers: string[] = lines[0].split(',');
    for (let i = 1; i < lines.length; i++) {
      let obj: SubscriberData = new SubscriberData();
      const line = lines[i].split(',');
      for (let j = 0; j < headers.length; j++) {
        switch (headers[j]) {
          case 'Username':
            obj.Username = line[j];
            break;
          case 'SubscribeDate':
            obj.SubscribeDate = new Date(line[j]);
            break;
          case 'CurrenTier':
            obj.CurrenTier = line[j];
            break;
          case 'Tenure':
            obj.Tenure = +line[j];
            break;
          case 'Streak':
            obj.Streak = +line[j];
            break;
          case 'Founder':
            obj.Founder = line[j] === 'true';
            break;
          case 'SubType':
          case 'Sub Type':
            obj.SubType = line[j];
            break;
          default:
            break;
        }
      }
      result.push(obj);
    }
    return result;
  }
  removeAward(index: number) {
    if (index > -1) {
      this.awards.splice(index, 1);
    }
  }

  addAward() {
    this.awards.push(new Award('PS50', 10));
  }

  async makeLotteryPool() {
    this.isProcessing = true;
    this.lotteryPool = [];
    await this.getUsers(this.subList);
    if (this.isForGifter) {
      this.subList  = await this.getGifter(this.subList);
      console.log("gifter result" , this.subList);
    }
    if (this.isTenureBouns) {
      if (this.tenureBounsMonths > 0) {
        this.subList.forEach((sub) => {
          if (sub.NickName) {
            for (let i = 0; i < sub.Tenure / this.tenureBounsMonths; i++) {
              this.lotteryPool.push(sub.NickName);
            }
            this.lotteryPool.push(sub.NickName);
          }
        });
      }
    } else {
      this.subList.forEach((sub) => {
        if (sub.NickName) {
          this.lotteryPool.push(sub.NickName);
        }
      });
    }
    console.log(this.lotteryPool);
    this.lotteryPool.sort(() => Math.random() - 0.5);
    console.log(this.lotteryPool);
    this.isProcessing = false;
  }
  async getGifter(subers: SubscriberData[]) {
    let count = 0;
    let getGifterData: GetGifterData = new GetGifterData();
    getGifterData.authorization = this.cookieService.get('access_token');
    getGifterData.broadcaster_id = this.broadcaster_id;
    getGifterData.ids = [];
    let subersMap = new Map<String, SubscriberData>();

    subers.forEach((suber) => {
      subersMap.set(suber.ID, suber);
    });

    for (let i = 0; i < subers.length; i++) {
      if (subers[i].ID && subers[i].SubType === 'gift') {
        count += 1;
        getGifterData.ids.push(subers[i].ID);
      }
      if (count === 100 || i === subers.length - 1) {
        count = 0;
        let response = await this.http
          .post(this.serverUrl + 'get_gifter/', JSON.stringify(getGifterData), {
            responseType: 'text',
          })
          .toPromise();
        let jsonData = JSON.parse(response);
        jsonData.data.forEach((dataItem) => {
          const suber = subersMap.get(dataItem.user_id);
          if(suber)
          {
            suber.Username = dataItem.gifter_login;
            suber.ID = dataItem.gifter_id;
            suber.NickName = dataItem.giftername;
          }
        });
        getGifterData.ids = [];
      }
    }

    return Array.from(subersMap.values());
  }

  async getUsers(subers: SubscriberData[]) {
    let getUsersData: GetUsersData = new GetUsersData();
    getUsersData.authorization = this.cookieService.get('access_token');
    for (let i = 0; i < subers.length; i += 100) {
      getUsersData.ids = [];
      for (let j = 0; j < 100 && i + j < subers.length; j++) {
        if (subers[i + j].Username !== '') {
          getUsersData.ids.push(subers[i + j].Username);
        }
      }
      let response = await this.http
        .post(this.serverUrl + 'get_users/', JSON.stringify(getUsersData), {
          responseType: 'text',
        })
        .toPromise();
      let jsonData = JSON.parse(response);
      jsonData.data.forEach((data) => {
        for (let k = 0; k < subers.length; k++) {
          let suber = subers[k];
          if (suber.Username === data.login) {
            suber.NickName = data.display_name;
            suber.ID = data.id;
          }
        }
      });
    }
  }

  twitchLogin() {
    let SERVER_URL = 'https://'+ window.location.host;
    let CLIENT_ID = 'dp74x753ef0ri5gopkz53a6l44a30k';
    window.location.href =
      'https://id.twitch.tv/oauth2/authorize?client_id=' +
      CLIENT_ID +
      '&redirect_uri=' +
      SERVER_URL +
      '&response_type=token&scope=channel:read:subscriptions';
  }

  checkAccessToken() {
    this.http
      .post(
        this.serverUrl + 'check_auth/',
        JSON.stringify({
          access_token: this.cookieService.get('access_token'),
        }),
        {
          responseType: 'text',
        }
      )
      .subscribe((response) => {
        let data = JSON.parse(response);
        if (data.message == 'invalid access token' || data.message == 'missing authorization token') {
          this.isTwitchLogin = false;
        } else {
          this.isTwitchLogin = true;
          this.broadcaster_id = data.user_id;
        }
      });
  }

  chooseToggleButton(awardName: string) {
    this.awards.forEach(award => {
      if (award.name === awardName) {
        this.chooseAward = award;
      }
    });
  }
}

class SubscriberData {
  Username: string;
  SubscribeDate: Date;
  CurrenTier: string;
  Tenure: number;
  Streak: number;
  Founder: boolean;
  SubType: string;
  ID: string;
  NickName: string;
}

class Award {
  name: string;
  numberOfPeople: number;
  winner: string[];
  constructor(name: string, numberOfPeople: number) {
    this.name = name;
    this.numberOfPeople = numberOfPeople;
    this.winner = [];
  }
}

class GetUsersData {
  authorization: string;
  ids: string[];
}

class GetGifterData {
  authorization: string;
  broadcaster_id: string;
  ids: string[];
}

class WinnerData {
  names: string[];
  constructor() {
    this.names = [];
  }
}
